<div class="dev-playground-page">
    <div class="dev-playground-header">Dev Playground</div>    
    <div class="page-container">
        <pm-combo-box [DisplayMemberPath]="'Name'" [ItemsSource]="TonsOfItems"></pm-combo-box>
        <pm-toolbar ToolbarClass="toolbar-top-border toolbar-left-border toolbar-right-border">
            <div class="toolbar-left"> 
                <div class="toolbar-left">Rows (389)</div>
                <div class="toolbar-divider"></div>
                <pm-button (click)="ExpandAll()" class="toolbar-button-container" ButtonClass="button-toolbar">
                    <pm-icon-expand-all></pm-icon-expand-all>
                </pm-button>
                <pm-button (click)="CollapseAll()" class="toolbar-button-container" ButtonClass="button-toolbar">
                    <pm-icon-collapse-all></pm-icon-collapse-all>
                </pm-button>                
                <pm-button (click)="ToggleIsBusy()" class="toolbar-button-container" ButtonClass="button-toolbar">
                    <pm-icon-refresh></pm-icon-refresh>
                </pm-button>                
            </div>
            <div class="toolbar-left"> 
                <pm-filter-box></pm-filter-box>
            </div>            
        </pm-toolbar>
        <pm-grid GridClass="grid-border-container" 
                GridSelectionMode="Row"
                [ContextMenu]="devPlayGroundContextMenu"
                [CalculateRowSize]="RowSize"
                [ShowFooter]="true"
                [ShowColumnGroups]="true"
                [HierarchyColumnIndex]="1"
                [HierarchyColumnProperty]="'Items'"
                [Columns]="Columns"
                [ColumnGroups]="ColumnGroups"
                [ItemsSource]="Items"
                RowMouseOver="cell-mouse-over-default"
                [IsBusy]="IsBusy"
                BusyMessage="Please Wait"></pm-grid>
        <pm-context-menu #devPlayGroundContextMenu AutoSelect>
            <pm-context-menu-header>Dev Playground Grid</pm-context-menu-header>            
            <pm-context-menu-item (click)="ToggleHighlightRow()">Toggle Highlight Row</pm-context-menu-item>
            <pm-context-menu-item (click)="ExportToExcel()">Export To Excel</pm-context-menu-item>
        </pm-context-menu>                
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/dev-playground/dev-playground.html